/**
 * Popover vertical align types.
 * @public
 */
enum PopoverVerticalAlign {
	/**
	 * @public
	 */
	Center = "Center",

	/**
	 * Popover will be placed at the top of the reference control.
	 * @public
	 */
	Top = "Top",

	/**
	 * Popover will be placed at the bottom of the reference control.
	 * @public
	 */
	Bottom = "Bottom",

	/**
	 * Popover will be streched
	 * @public
	 */
	Stretch = "Stretch",
}

export default PopoverVerticalAlign;
